import * as types from "~/store/user/userType";
import * as typesLogin from "~/store/login/types";
import { openToast } from "~/components/common/molecules/ToastNotification";

const initialState = {
  IsAuthenticated: false,
  info: null,
  error: "",
  loginSMS: {
    getCode: null,
    loading: false
  },
  registerSMS: {
    getCode: {},
    secretKey: "",
    accountRegistered: null
  },
  forgotPass: false,
  socialInfo: {
    requiredPhone: false
  },
  isCallApiGetOtp: false,
  loading: false,
  flow: "password"
};

export default function locale(state = initialState, action = {}) {
  switch (action.type) {
    case types.GET_USER_INFO_BY_CODE_SUCCESS:
      return {
        ...state,
        IsAuthenticated: true,
        info: action.userInfo,
        error: ""
      };
    case types.GET_USER_INFO_BY_CODE_FAIL:
      return { ...state, error: action.error };
    case types.USER_LOG_OUT:
      window.localStorage.removeItem("jwt");
      openToast("Bạn đã đăng xuất thành công");

      return initialState;
    case types.USER_LOG_OUT_WITHOUT_NOTI:
      return {
        ...state,
        IsAuthenticated: initialState.IsAuthenticated,
        info: { ...initialState.info }
      };
    case types.USER_SESSSION_EXPIRED:
      return {
        ...state,
        ...initialState
      };

    // LOGIN SMS
    case types.GET_CODE_LOGIN_SMS: {
      return {
        ...state,
        loginSMS: { ...initialState.loginSMS, loading: true }
      };
    }

    case types.GET_CODE_LOGIN_SMS_SUCCESS: {
      return {
        ...state,
        loginSMS: { ...state.loginSMS, getCode: action.data, loading: false }
      };
    }
    case types.RESET_DATA_LOGIN_SMS: {
      return initialState;
    }

    case types.GET_CODE_REGISTER_SMS: {
      return {
        ...state,
        loading: true,
        registerSMS: { ...state.registerSMS, getCode: {} }
      };
    }
    case types.GET_CODE_REGISTER_SMS_SUCCESS: {
      // console.log(action.otpInfo);
      return {
        ...state,
        registerSMS: {
          ...state.registerSMS,
          getCode: action.otpInfo,
          secretKey: ""
        },
        isCallApiGetOtp: true,
        loading: false
      };
    }
    case types.GET_CODE_REGISTER_SMS_ERROR: {
      return { ...state, loading: false };
    }

    case types.CHECK_CODE_REGISTER_SMS: {
      return { ...state, loading: true };
    }
    case types.CHECK_CODE_REGISTER_SMS_SUCCESS: {
      // console.log(action.secretKey);
      return {
        ...state,
        registerSMS: { ...state.registerSMS, secretKey: action.secretKey },
        loading: false
      };
    }
    case types.CHECK_CODE_REGISTER_SMS_ERROR: {
      return { ...state, loading: false };
    }

    case types.APPLY_PASS_REGISTER_SMS: {
      return { ...state, loading: true };
    }
    case types.APPLY_PASS_REGISTER_SMS_SUCCESS: {
      return {
        ...state,
        registerSMS: {
          ...state.registerSMS,
          accountRegistered: action.accountRegistered
        },
        loading: false
      };
    }
    case types.APPLY_PASS_REGISTER_SMS_ERROR: {
      return {
        ...state,
        loading: false
      };
    }

    case types.LOGIN_WITH_PASSWORD: {
      return {
        ...state,
        loading: true
      };
    }
    case types.LOGIN_WITH_PASSWORD_SUCCESS: {
      return {
        ...state,
        loading: false,
        registerSMS: {
          ...state.registerSMS,
          getCode: {},
          secretKey: "",
          accountRegistered: null
        },
        IsAuthenticated: true,
        info: action.userLogin
      };
    }
    case types.LOGIN_WITH_PASSWORD_ERROR: {
      // console.log(action.userLogin);
      return {
        ...state,
        loading: false
      };
    }

    case typesLogin.CHANGE_STEP: {
      return {
        ...state,
        forgotPass: action.payload === 5 ? true : state.forgotPass
      };
    }

    case types.REGISTER_SOCIAL:
      return {
        ...state,
        loading: true
      };
    case types.REGISTER_SOCIAL_SUCCESS:
      // console.log(action.accountRegistered);
      return {
        ...state,
        registerSMS: {
          ...state.registerSMS,
          accountRegistered: action.accountRegistered
        },
        requireRegister: false,
        loading: false
      };
    case types.REGISTER_SOCIAL_ERROR:
      return {
        ...state,
        loading: false
      };

    case types.SET_TYPE_SOCIAL: {
      return {
        ...state,
        socialInfo: { ...state.socialInfo, typeAccess: action.payload }
      };
    }

    case types.LOGIN_SOCIAL_SIGNIN:
      return {
        ...state,
        loading: true,
        flow: action.typeAccess
      };
    case types.LOGIN_SOCIAL_SIGNIN_SUCCESS:
      return {
        ...state,
        registerSMS: {
          ...state.registerSMS,
          getCode: {},
          secretKey: "",
          accountRegistered: null
        },
        IsAuthenticated: true,
        info: action.userLogin,
        socialInfo: {
          ...state.socialInfo,
          requiredPhone: false
        }
      };
    case types.LOGIN_SOCIAL_SIGNIN_ERROR:
      return {
        ...state,
        loading: false
      };

    case types.REQUIRE_REGISTER_SOCIAL:
      return {
        ...state,
        socialInfo: action.socialInfo,
        loading: false
      };

    case types.CLEAR_INTERVAL:
      return {
        ...initialState,
        IsAuthenticated: state.IsAuthenticated,
        info: { ...state.info }
      };

    case types.CLEAR_OTP_INFO: {
      return {
        ...state,
        registerSMS: {
          ...state.registerSMS,
          getCode: {
            ...initialState.registerSMS.getCode
          }
        }
      };
    }

    case types.CLEAR_ERROR:
      return { ...state, error: "" };

    case types.FORGOT_PASSWORD: {
      return {
        ...state,
        registerSMS: {
          ...state.registerSMS,
          getCode: { ...initialState.registerSMS.getCode }
        }
      };
    }

    default:
      return state;
  }
}
